import type { ModelType } from 'src/api/models';

/**
 * UI-facing options for the modelType radio control.
 */
export const MODEL_TYPE_OPTIONS: Array<{
  value: ModelType;
  label: string;
  description: string;
}> = [
  {
    value: 'mm',
    label: 'Marketing Mix',
    description:
      "Use when your model includes a mix of digital and offline channels (e.g. TV, Radio, Outdoor, Press alongside Facebook, Google, etc.). Measures the combined impact across all media types. Pick this if you're unsure — it's the safer default and works for any channel mix.",
  },
  {
    value: 'da',
    label: 'Digital Attribution',
    description:
      'Use when measuring only digital channels (Facebook, Google, TikTok, Instagram, etc.). Tuned for the way digital media drives short-term, conversion-focused impact. Offline channels (TV, Radio, Outdoor, Press) are not supported in this mode — if you need them, pick Marketing Mix instead.',
  },
  {
    value: 'lt',
    label: 'Long-term',
    description:
      'Measures the long-term brand-building effect of your media on top of the short-term impact, using share-of-search data. Built on an existing published Marketing Mix model — its KPI, media, and campaign setup are reused automatically.',
  },
];
